import { render, staticRenderFns } from "./Subvencion.vue?vue&type=template&id=430f4fa6&scoped=true"
import script from "./Subvencion.vue?vue&type=script&lang=js"
export * from "./Subvencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f4fa6",
  null
  
)

export default component.exports